import { captureCustomizerMessage } from "./sentry";
import { getImageHost } from "./merchImageProcessor";

// A broken generated preview image never throws; the customer just sees an empty
// frame. Report each failing URL once so dead links (e.g. expired Dropbox files)
// show up in Sentry instead of only in the customer's console.
export const createPreviewImageErrorReporter = ({ component, getProductType = () => "unknown" }) => {
    const reportedUrls = new Set();

    return (event) => {
        const src = event?.target?.currentSrc || event?.target?.src || "";
        if (!src || src.startsWith("data:") || reportedUrls.has(src)) return;
        reportedUrls.add(src);

        captureCustomizerMessage("customizer_preview_image_load_failed", {
            level: "error",
            tags: {
                component,
                product_type: getProductType() || "unknown",
                image_host: getImageHost(src),
            },
        });
    };
};
